export const SHOW_MORE_NUM = 5;
export const INITIAL_RESULT_SET_SIZE = 5;
